// services/atualizarApartamento.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
// --------------------- Import Interface ---------------------
import { Apartamento } from "../interfaces/Apartamento";

export const atualizarApartamento = async (
  aptoId: number | undefined,
  valuesAp: Apartamento
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/apto/${aptoId}`;
    try {
      const response = await axios.put(URL, valuesAp, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
